import { createContext, useContext } from "react";

const NavigationContext = createContext();

const useNavigationHandler = () => useContext(NavigationContext);

export { NavigationContext, useNavigationHandler };
